import { render } from "./TypeCommerce.vue?vue&type=template&id=1efc393c"
import script from "./TypeCommerce.vue?vue&type=script&lang=js"
export * from "./TypeCommerce.vue?vue&type=script&lang=js"

import exportComponent from "/Users/pmerkuloff/Web/hlv/FRONT/hpanel/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__